/* eslint-disable react/require-default-props */
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable react/jsx-indent */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useCallback, useEffect } from 'react';
import {
  MdSearch,
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdRadioButtonChecked,
  MdRadioButtonUnchecked,
} from 'react-icons/md';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from 'react-redux';

import { Button, CircularProgress } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useDebounce } from 'use-debounce';

import colors from '~/styles/colors';

import {
  Container,
  SkeletonContainer,
  ContentFooter,
  ContainerInputSearch,
  FooterContainer,
} from './styles';

interface BaseProps {
  id: string;
  value: string;
  label: string;
}

type TypeKeys<Type> = keyof Type;

type Props<Type> = {
  values: Type[] | null;
  onLoad: (
    genericParams: any,
    search: string,
    page: number,
    limit: number,
  ) => void;
  callback: (values: Type[], hasChanged?: boolean) => void;
  pathToList: string;
  pathToLoading: string;
  pathToTotal: string;
  pathToData: string;
  mapProps: Record<TypeKeys<Type>, string>;
  // eslint-disable-next-line react/require-default-props
  genericParams?: any;
  // eslint-disable-next-line react/require-default-props
  isMulti?: boolean;
};

type Option<Type> = Type & {
  checked?: boolean;
};

function DataList<Type extends BaseProps>({
  values,
  callback,
  onLoad,
  genericParams,
  pathToList,
  pathToLoading,
  pathToTotal,
  pathToData,
  mapProps,
  isMulti = false,
}: Props<Type>): JSX.Element {
  const [options, setOptions] = useState<Option<Type>[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<Type[]>([]);
  const [search, setSearch] = useState<string>('');
  const [searchDebounce] = useDebounce(search, 800);
  const [loadingCount, setLoadingCount] = useState<number>(0);

  const stateData = useSelector((state: any) => state[pathToList]) as any;

  const loading = stateData[pathToLoading] as boolean;
  const total = stateData[pathToTotal] as number;
  const data = stateData[pathToData] as any[];

  const loadData = useCallback(
    (page, limit) => {
      onLoad(genericParams, searchDebounce, page, limit);
    },
    [genericParams, onLoad, searchDebounce],
  );

  const handleLoad = () => {
    const page = 1;
    loadData(page, options.length + 5);
  };

  const hasThisOption = (id: string): boolean => {
    return !!selectedOptions.find((option) => option.id === id);
  };

  const handleAddOption = (incomingOption: Option<Type>) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { checked, ...rest } = incomingOption;

    const selectedValue = rest as Type;
    const newSelectedOptions = selectedOptions.filter(
      ({ id }) => id !== selectedValue.id,
    );
    setSelectedOptions(
      hasThisOption(selectedValue.id)
        ? [...newSelectedOptions]
        : [...newSelectedOptions, selectedValue],
    );
  };

  const handleAddSingleOption = (incomingOption: Option<Type>) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { checked: _, ...rest } = incomingOption;

    const selectedValue = rest as Type;
    setSelectedOptions([selectedValue]);
  };

  const compareIfHasChanged = (): boolean => {
    if (
      (selectedOptions && !values) ||
      (!selectedOptions && values) ||
      selectedOptions.length !== values?.length
    ) {
      return true;
    }

    let hasChanged = false;
    if (values && selectedOptions) {
      selectedOptions.forEach(({ value: optionValue }) => {
        if (values.some(({ value }) => value === optionValue) === false) {
          hasChanged = true;
        }
      });
    }
    return hasChanged;
  };

  const handleSubmit = () => {
    const hasChanged = compareIfHasChanged();
    callback(selectedOptions, hasChanged);
  };

  useEffect(() => {
    if (data instanceof Array) {
      const dataOptions: Option<Type>[] = data.map((value) => {
        const option = {} as Option<Type>;
        Object.entries(mapProps).forEach(([key, path]) => {
          Object.assign(option, {
            [key]: value[path],
          });
        });
        return option;
      });

      setOptions(dataOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    const page = 1;
    const limit = 10;

    loadData(page, limit);
  }, [loadData, searchDebounce]);

  useEffect(() => {
    setSelectedOptions(values || []);
  }, [values]);

  useEffect(() => {
    setLoadingCount(loadingCount + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <Container>
      <ContainerInputSearch>
        <MdSearch size={25} />
        <input
          aria-label="search-input"
          id="search-input"
          type="text"
          placeholder="Buscar dados"
          onChange={(e) => setSearch(e.target.value)}
        />
        {loading && <CircularProgress size={24} color="primary" />}
      </ContainerInputSearch>

      <ul>
        <InfiniteScroll
          dataLength={options.length}
          next={handleLoad}
          hasMore={options.length !== total}
          loader=""
          height="230px"
        >
          {loadingCount < 3
            ? Array.from(Array(5)).map((value, index) => (
                <SkeletonContainer key={`skeleton-${index}`}>
                  <Skeleton animation="wave" width="100%" height={45} />
                </SkeletonContainer>
              ))
            : options.length > 0 &&
              options.map((option) => (
                <li
                  key={option.id}
                  role="button"
                  onClick={
                    isMulti
                      ? () => handleAddOption(option)
                      : () => handleAddSingleOption(option)
                  }
                >
                  {isMulti ? (
                    hasThisOption(option.id) ? (
                      <MdCheckBox size={24} color={colors.primary} />
                    ) : (
                      <MdCheckBoxOutlineBlank
                        onClick={() => handleAddOption(option)}
                        size={24}
                        color="#b4b4b4"
                      />
                    )
                  ) : (
                    <>
                      {hasThisOption(option.id) ? (
                        <MdRadioButtonChecked
                          size={24}
                          color={colors.primary}
                        />
                      ) : (
                        <MdRadioButtonUnchecked
                          size={24}
                          color="#b4b4b4"
                          onClick={() => handleAddSingleOption(option)}
                        />
                      )}
                    </>
                  )}
                  <label htmlFor="dataList">{option.label}</label>
                </li>
              ))}
          {!loading &&
            options.length === 0 &&
            'Sua pesquisa está correta? Não encontramos informações :('}
        </InfiniteScroll>
      </ul>

      <FooterContainer>
        <ContentFooter>
          <Button
            type="button"
            disabled={loading || !selectedOptions}
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            style={{ width: '100%' }}
          >
            Confirmar seleção
          </Button>
        </ContentFooter>
      </FooterContainer>
    </Container>
  );
}

export default DataList;
